var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAvailablePage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 244,
    viewBox: "0 0 548 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.938 12.5C270.632 7.83335 277.368 7.83334 280.062 12.5L371.861 171.5C374.555 176.167 371.187 182 365.799 182H182.201C176.813 182 173.445 176.167 176.139 171.5L267.938 12.5Z",
    fill: "url(#paint0_linear_1771_985)",
    stroke: "#BB9370",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270.536 38C272.076 35.3333 275.924 35.3333 277.464 38L348.478 161C350.018 163.667 348.093 167 345.014 167H202.986C199.907 167 197.982 163.667 199.522 161L270.536 38Z",
    fill: "url(#paint1_linear_1771_985)",
    stroke: "#434343",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.046 116.222C278.434 116.222 282 112.613 282 108.293V82.8304C282 78.5012 278.434 75 274.046 75C269.657 75 266 78.5012 266 82.8304V108.293C266 112.613 269.657 116.222 274.046 116.222ZM266 139.079C266 143.391 269.657 147 274.046 147C278.434 147 282 143.391 282 138.98C282 134.669 278.434 131.15 274.046 131.15C269.657 131.15 266 134.75 266 139.079Z",
    fill: "#E7D5B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M281.5 108.293C281.5 112.338 278.157 115.722 274.046 115.722V116.722C278.711 116.722 282.5 112.888 282.5 108.293H281.5ZM281.5 82.8304V108.293H282.5V82.8304H281.5ZM274.046 75.5C278.166 75.5 281.5 78.7851 281.5 82.8304H282.5C282.5 78.2173 278.703 74.5 274.046 74.5V75.5ZM266.5 82.8304C266.5 78.7924 269.918 75.5 274.046 75.5V74.5C269.396 74.5 265.5 78.21 265.5 82.8304H266.5ZM266.5 108.293V82.8304H265.5V108.293H266.5ZM274.046 115.722C269.927 115.722 266.5 112.33 266.5 108.293H265.5C265.5 112.896 269.388 116.722 274.046 116.722V115.722ZM274.046 146.5C269.926 146.5 266.5 143.107 266.5 139.079H265.5C265.5 143.674 269.388 147.5 274.046 147.5V146.5ZM281.5 138.98C281.5 143.119 278.154 146.5 274.046 146.5V147.5C278.715 147.5 282.5 143.662 282.5 138.98H281.5ZM274.046 131.65C278.165 131.65 281.5 134.952 281.5 138.98H282.5C282.5 134.386 278.703 130.65 274.046 130.65V131.65ZM266.5 139.079C266.5 135.033 269.926 131.65 274.046 131.65V130.65C269.388 130.65 265.5 134.467 265.5 139.079H266.5Z",
    fill: "#E7D5B9",
    fillOpacity: 0.24
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 94C0 92.8954 0.895431 92 2 92H198.518C200.062 92 201.023 93.6744 200.245 95.0077L188.579 115.008C188.22 115.622 187.563 116 186.851 116H2C0.89543 116 0 115.105 0 114V94Z",
    fill: "url(#paint2_linear_1771_985)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M548 94C548 92.8954 547.105 92 546 92H351.482C349.938 92 348.977 93.6744 349.755 95.0077L361.421 115.008C361.78 115.622 362.437 116 363.149 116H546C547.105 116 548 115.105 548 114V94Z",
    fill: "url(#paint3_linear_1771_985)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1771_985",
    x1: 274,
    y1: 44,
    x2: 274,
    y2: 183.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B191A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2A2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1771_985",
    x1: 274,
    y1: 64.459,
    x2: 274,
    y2: 167.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B191A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2A2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1771_985",
    x1: 0,
    y1: 104,
    x2: 207,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2A2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2A2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1771_985",
    x1: 548,
    y1: 104,
    x2: 341,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2A2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2A2B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvailablePage);
export default __webpack_public_path__ + "static/media/no-available-page.bffe991da9ebf2a606afbea20c461500.svg";
export { ForwardRef as ReactComponent };